import { Type } from 'class-transformer';

import { Company } from '../../models/company.model';

/**
 * A named list of {@link Company|Companies} defined by a {@link Company} to
 * select several counterparts at once when creating a private Order.
 *
 * It is a shortcut: applying it copies its members into the Order, so later
 * changes to the group do not affect Orders already created.
 */
export class CompanyGroup {
  /** Agree's internal unique identifier. */
  readonly id: number;
  name: string;
  description?: string;
  readonly members_count?: number;

  /** Only available when retrieving a single group. */
  @Type(() => Company)
  members?: Company[];

  constructor(data: Partial<CompanyGroup> = {}) {
    Object.assign(this, data);
  }
}
